import React, { Component, createRef } from 'react';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';
import { Trans, withI18n } from '@lingui/react';
import { i18n } from "@lingui/core";
import { t } from '@lingui/macro';
import { env as serverEnv } from '../../server/env';
import { langFromPath } from '../i18n-config';

class InquiryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      platforms: '',
      status: '',
      firstName: '',
      lastName: '',
      email: '',
      message: ''
    };
    this.captcha = null;
    this.handleRecaptcha = this.handleRecaptcha.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.lang = null;
    this.form = React.createRef();
    this.onFormSubmit = props.onFormSubmit;
  }

  handleRecaptcha = ((response) => {
    this.setState({
      g_recaptcha_response: response,
    });
  });

  handleSubmit = (e) => {
    const { firstName, lastName, email, message } = this.state;

    e.preventDefault();

    axios({
      url: process.env.GATSBY_FORMSPREE_API_CONTACT_FORM_POST || 'https://formspree.io/f/xayvzlro',
      method: 'post',
      headers: {
        'Accept': 'application/json'
      },
      data: {
        firstname: firstName,
        lastname: lastName,
        email,
        message
      }
    }).then((response) => {
      let message;

      if (response.data.ok) {
        message = 'Thank you for contacting us.<br /> Our precogs will reach out to you shortly.';
        this.form.current.reset()

        if (this.onFormSubmit) {
          this.onFormSubmit(message);
        }
      } else {
        message = 'An error has occured. Please try again later.'

        response.json().then(data => {
          if (Object.hasOwn(data, 'errors')) {
            message = data["errors"].map(error => error["message"]).join(", ")
          }
        })
      }
      this.setState({ status: message });
    })
    .catch((error) => {
      this.setState({ status: 'An error has occured. Please try again later.' });
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  }

  render() {
    let lang = '';
    if (typeof window !== 'undefined') {
      lang = langFromPath(window.location.pathname);
      window.recaptchaOptions = {
        lang,
        removeOnUnmount: true,
      };
      this.lang = window.recaptchaOptions;
    }
    const { status: formStatus } = this.state;
    const message = <p className="message">{formStatus}</p>;

    return (
      <div className="inquiry-wrapper">
        <form
          ref={this.form}
          id="my-form"
          className="form"
          method="POST"
          onSubmit={this.handleSubmit}
        >
          <div className="row">
            <fieldset className="col-xs-12 col-sm-6">
              <label htmlFor="firstName">
                <span className="form__label"><Trans>Your First Name</Trans></span>
                <input name="firstName" required id="first_name" type="text" onChange={this.handleInputChange} />
              </label>
            </fieldset>
            <fieldset className="col-xs-12 col-sm-6">
              <label htmlFor="lastName">
                <span className="form__label"><Trans>Your Last Name</Trans></span>
                <input name="lastName" required id="last_name" type="text" onChange={this.handleInputChange} />
              </label>
            </fieldset>
          </div>
          <div className="row">
            <fieldset className="col-xs-12 col-lg-12">
              <label htmlFor="email">
                <span className="form__label"><Trans>Your Email Address</Trans></span>
                <input name="email" required id="email" type="email" onChange={this.handleInputChange} />
              </label>
            </fieldset>
          </div>
          <div className="row">
            <fieldset required className="col-xs-12">
              <label htmlFor="message">
                <span className="form__label"><Trans>Your Message</Trans></span>
                <textarea name="message" id="message" required onChange={this.handleInputChange} />
              </label>
            </fieldset>
          </div>
          {/* <input type="text" name="_gotcha" style={{display:'none'}} /> */}
          <div className="form__actions">
            <button className="button button--blue" >
              <Trans>Send your message</Trans>
            </button>
          </div>
        </form>
        { message }
      </div>
    );
  }
}

export default withI18n()(InquiryForm);
